module.exports = __webpack_public_path__ + "static/media/video-thumb.35116068.png";